import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Form, Input, App, Space, Select, Tag } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined, EyeOutlined } from '@ant-design/icons';
import request from '../utils/request';

const Appointment = () => {
  const { message } = App.useApp();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [detailVisible, setDetailVisible] = useState(false);
  const [form] = Form.useForm();
  const [editingRecord, setEditingRecord] = useState(null);
  const [viewRecord, setViewRecord] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await request.get('/appointment/list');
      if (res.code === 200) {
        setData(res.data.list || []);
      }
      setLoading(false);
    } catch (error) {
      message.error('获取数据失败');
      setLoading(false);
    }
  };

  const handleView = (record) => {
    setViewRecord(record);
    setDetailVisible(true);
  };

  const handleApprove = async (id) => {
    try {
      await request.put('/appointment/' + id + '/approve');
      message.success('审核通过');
      fetchData();
    } catch (error) {
      message.error('审核失败');
    }
  };

  const handleReject = async (id) => {
    try {
      await request.put('/appointment/' + id + '/reject');
      message.success('已拒绝');
      fetchData();
    } catch (error) {
      message.error('操作失败');
    }
  };

  const columns = [
    { title: 'ID', dataIndex: 'id', key: 'id', width: 60 },
    { title: '访客姓名', dataIndex: 'visitor_name', key: 'visitor_name' },
    { title: '访客电话', dataIndex: 'visitor_phone', key: 'visitor_phone' },
    { title: '访问房号', dataIndex: 'room_info', key: 'room_info' },
    { title: '访问日期', dataIndex: 'visit_date', key: 'visit_date' },
    { title: '访问时间', dataIndex: 'visit_time', key: 'visit_time' },
    { title: '状态', dataIndex: 'status', key: 'status', render: (text) => {
      const colors = { 
        pending: 'orange', 
        approved: 'green', 
        rejected: 'red', 
        checked_in: 'blue', 
        expired: 'gray' 
      };
      const labels = { 
        pending: '待审核', 
        approved: '已通过', 
        rejected: '已拒绝', 
        checked_in: '已核销', 
        expired: '已过期' 
      };
      return <Tag color={colors[text]}>{labels[text] || text}</Tag>;
    }},
    {
      title: '操作',
      key: 'action',
      render: (_, record) => (
        <Space>
          <Button type="link" icon={<EyeOutlined />} onClick={() => handleView(record)}>查看</Button>
          {record.status === 'pending' && (
            <>
              <Button type="link" onClick={() => handleApprove(record.id)}>通过</Button>
              <Button type="link" danger onClick={() => handleReject(record.id)}>拒绝</Button>
            </>
          )}
        </Space>
      )
    }
  ];

  return (
    <div>
      <div style={{ marginBottom: 16 }}>
        <Button type="primary" icon={<PlusOutlined />}>添加预约</Button>
      </div>

      <Table columns={columns} dataSource={data} rowKey="id" loading={loading} pagination={{ pageSize: 10 }} />

      <Modal
        title="预约详情"
        open={detailVisible}
        onCancel={() => setDetailVisible(false)}
        footer={null}
      >
        {viewRecord && (
          <div>
            <h4>访客信息</h4>
            <p>姓名: {viewRecord.visitor_name}</p>
            <p>电话: {viewRecord.visitor_phone}</p>
            <p>人数: {viewRecord.visitor_count}人</p>
            
            <h4>访问信息</h4>
            <p>房号: {viewRecord.room_info}</p>
            <p>日期: {viewRecord.visit_date}</p>
            <p>时间: {viewRecord.visit_time}</p>
            <p>目的: {viewRecord.purpose}</p>
            
            <h4>状态</h4>
            <Tag color={viewRecord.status === 'approved' ? 'green' : viewRecord.status === 'pending' ? 'orange' : 'red'}>
              {viewRecord.status === 'pending' ? '待审核' : viewRecord.status === 'approved' ? '已通过' : '已拒绝'}
            </Tag>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default Appointment;
